// src/config/contentVisibility.js
// §8ter — Séparation obligatoire des contenus. Source unique de vérité pour la
// visibilité d'un contenu/document partageable dans l'espace Advisor. Par défaut
// PERSONNE ne voit une donnée non explicitement attribuée : tout part en
// `advisor_private`. Toute surface qui expose un contenu à un client/tiers doit
// vérifier cette visibilité côté serveur (RLS), jamais seulement masquer un bouton.

export const VISIBILITY = {
  ADVISOR_PRIVATE: "advisor_private",   // Advisor uniquement
  ADVISOR_TEAM: "advisor_team",         // membres autorisés du cabinet
  CLIENT_SHARED: "client_shared",       // client relié + équipe autorisée
  EXTERNAL_SHARED: "external_shared",   // tiers désigné, durée et périmètre limités
};

export const VISIBILITY_VALUES = Object.values(VISIBILITY);

// Défaut par type de contenu (§8ter). Note/brouillon/hypothèse de valeur/marge/
// prix de revient/commentaire interne = advisor_private. Document importé par le
// client = client_shared. Rapport final = advisor_private JUSQU'À « Partager ».
export const DEFAULT_VISIBILITY_BY_KIND = {
  note: VISIBILITY.ADVISOR_PRIVATE,
  draft: VISIBILITY.ADVISOR_PRIVATE,
  valuation_hypothesis: VISIBILITY.ADVISOR_PRIVATE,
  margin: VISIBILITY.ADVISOR_PRIVATE,
  cost_price: VISIBILITY.ADVISOR_PRIVATE,
  internal_comment: VISIBILITY.ADVISOR_PRIVATE,
  quote: VISIBILITY.ADVISOR_PRIVATE,          // devis privé tant que non envoyé
  report_final: VISIBILITY.ADVISOR_PRIVATE,   // privé jusqu'à action « Partager »
  client_document: VISIBILITY.CLIENT_SHARED,  // pièce déposée par le client
};

export function defaultVisibilityFor(kind) {
  return DEFAULT_VISIBILITY_BY_KIND[kind] || VISIBILITY.ADVISOR_PRIVATE;
}

// Un contenu est-il visible du client relié ?
export function isClientVisible(v) {
  return v === VISIBILITY.CLIENT_SHARED || v === VISIBILITY.EXTERNAL_SHARED;
}

// Ce qui n'est JAMAIS partagé au client lors d'un envoi (pour l'écran « Voir comme
// le client » / récap de partage) : notes internes, brouillons, honoraires, marges.
export const NEVER_SHARED_KINDS = ["note", "draft", "margin", "cost_price", "internal_comment"];

export const VISIBILITY_LABELS = {
  fr: {
    advisor_private: "Advisor uniquement",
    advisor_team: "Équipe du cabinet",
    client_shared: "Partagé avec le client",
    external_shared: "Tiers désigné (limité)",
  },
  en: {
    advisor_private: "Advisor only",
    advisor_team: "Firm team",
    client_shared: "Shared with client",
    external_shared: "Designated third party (limited)",
  },
  de: {
    advisor_private: "Nur Advisor",
    advisor_team: "Kanzlei-Team",
    client_shared: "Mit Kunde geteilt",
    external_shared: "Benannter Dritter (begrenzt)",
  },
};

export function visibilityLabel(v, lang) {
  const l = String(lang || "fr").slice(0, 2).toLowerCase();
  return (VISIBILITY_LABELS[l] || VISIBILITY_LABELS.fr)[v] || v;
}

// Actions d'audit standard (§8ter journalisation) — vocabulaire commun.
export const AUDIT_ACTIONS = {
  DOSSIER_CREATED: "dossier_created",
  COLLECTION_ATTACHED: "collection_attached",
  COLLECTION_DETACHED: "collection_detached",
  MISSION_ATTACHED: "mission_attached",
  MISSION_DETACHED: "mission_detached",
  INVITATION_CREATED: "invitation_created",
  INVITATION_ACCEPTED: "invitation_accepted",
  INVITATION_DECLINED: "invitation_declined",
  DOSSIER_ARCHIVED: "dossier_archived",
};
